"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

var _react = require("react");

var React = _interopRequireWildcard(_react);

var _selectn = require("selectn");

var _selectn2 = _interopRequireDefault(_selectn);

var _lodash = require("lodash");

var _reactBootstrap = require("react-bootstrap");

var _reactRouter = require("react-router");

var _reactIntl = require("react-intl");

var _reactCssModules = require("react-css-modules");

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _reactRedux = require("react-redux");

var _ReportDetailAddEditTypeModal = require("./ReportDetailAddEditTypeModal");

var _ReportDetailAddEditTypeModal2 = _interopRequireDefault(_ReportDetailAddEditTypeModal);

var _ReportDetailDeleteTypeContentModal = require("./ReportDetailDeleteTypeContentModal");

var _ReportDetailDeleteTypeContentModal2 = _interopRequireDefault(_ReportDetailDeleteTypeContentModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var styles = require("./ReportDetailTypeContent.less");
var ReportDetailTypeContent = function (_React$Component) {
    _inherits(ReportDetailTypeContent, _React$Component);

    function ReportDetailTypeContent(props) {
        _classCallCheck(this, ReportDetailTypeContent);

        var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(ReportDetailTypeContent).call(this, props));

        _this.showModal = function (modal, show) {
            var item = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];

            if (show) {
                _this.setState({
                    showModal: modal,
                    selectedItem: item
                });
            } else {
                _this.setState({
                    showModal: null,
                    selectedItem: null
                });
            }
        };
        _this.buildTableBody = function () {
            return (0, _lodash.chain)(_this.props.currentReportData.dataEntries).map(function (entry) {
                var imageComponent = null; // only relevant for issues
                var descriptionComponent = void 0;
                if (_this.props.currentReportData.dataKey === "issues") {
                    var description = entry.description;

                    descriptionComponent = React.createElement("td", null, description);
                    // if the issue has an image set, show the first here.
                    console.log(entry);
                    var issueData = entry;
                    if ((0, _lodash.isArray)(issueData.attachmentUids) === true && issueData.attachmentUids.length > 0) {
                        var extension = "";
                        if (issueData.attachmentUids[0].indexOf("PDF") !== -1) {
                            extension = ".pdf";
                        } else {
                            extension = ".png";
                        }
                        var picUrl = __API_BASE_URL__ + "/assets/attachments/reports/" + _this.props.reportDetail.selectedReport.uid + "/" + issueData.attachmentUids[0];
                        imageComponent = React.createElement("a", { href: picUrl + extension, target: "_blank" }, React.createElement("img", { width: "auto", height: "40px", src: picUrl + "THUMBNAIL.png", style: { marginRight: 8 } }));
                    }
                }
                var additionalInfoComponent = void 0;
                if (_this.props.currentReportData.dataKey === "objects" || _this.props.currentReportData.dataKey === "items") {
                    var additionalInfo = entry.additionalInfo;

                    additionalInfoComponent = React.createElement("td", null, additionalInfo);
                }
                return React.createElement("tr", { key: entry.uid }, React.createElement("td", null, imageComponent, entry.title), additionalInfoComponent, descriptionComponent, React.createElement("td", null, function () {
                    // don't render edit buttons if the user is not the owner of the report.
                    if (_this.isReportModificationDisallowed() === false) {
                        return React.createElement(_reactBootstrap.ButtonGroup, { className: "pull-right" }, React.createElement(_reactRouter.Link, { to: "/reports/detail/" + _this.props.reportDetail.selectedReport.uid + "/" + _this.props.currentReportData.dataKey + "/" + _this.props.currentReportData.dataDefinition.uid + "/" + entry.uid, className: "btn btn-xs btn-default" }, React.createElement("i", { className: "fa fa-edit" }), " ", React.createElement(_reactIntl.FormattedMessage, { id: "reportList.edit.title" })), React.createElement(_reactBootstrap.Button, { onClick: function onClick() {
                                return _this.showModal("delete", true, entry);
                            }, bsSize: "xsmall" }, React.createElement("i", { className: "fa fa-times" }), " ", React.createElement(_reactIntl.FormattedMessage, { id: "reportList.delete.title" })));
                    } else {
                        return React.createElement(_reactBootstrap.ButtonGroup, { className: "pull-right" }, React.createElement(_reactRouter.Link, { to: "/reports/detail/" + _this.props.reportDetail.selectedReport.uid + "/" + _this.props.currentReportData.dataKey + "/" + _this.props.currentReportData.dataDefinition.uid + "/" + entry.uid, className: "btn btn-xs btn-default" }, React.createElement("i", { className: "fa fa-eye" }), " ", React.createElement(_reactIntl.FormattedMessage, { id: "reportList.show.title" })));
                    }
                }()));
            }).thru(function (tableRows) {
                return React.createElement("tbody", null, tableRows);
            }).value();
        };
        _this.buildTableHeader = function () {
            var additionalInfoTitle = _this.props.currentReportData.dataDefinition.additionalInfoTitle;

            var additionlInfoHeader = additionalInfoTitle ? React.createElement("th", null, additionalInfoTitle) : null;
            var descriptionComponent = _this.props.currentReportData.dataKey === "issues" ? React.createElement("th", null, React.createElement(_reactIntl.FormattedMessage, { id: "reportDetail.type.new.modal.description.title" })) : null;
            return React.createElement("thead", null, React.createElement("tr", null, React.createElement("th", null, _this.props.currentReportData.dataDefinition.nameSingular), additionlInfoHeader, descriptionComponent, React.createElement("th", null)));
        };
        _this.state = {
            showModal: null,
            selectedItem: null
        };
        return _this;
    }

    _createClass(ReportDetailTypeContent, [{
        key: "isReportModificationDisallowed",
        value: function isReportModificationDisallowed() {
            var uid = (0, _selectn2.default)("appUserProfile.uid", this.props.user);
            var permission = this.props.auth.highestPermission;
            var isManager = permission !== "user";
            var isOwnReport = uid === this.props.reportDetail.selectedReport.userUid;
            var isSharedWithUser = this.props.reportDetail.selectedReport.sharedWith.indexOf(this.props.user.appUserProfile.UserId) !== -1;
            if (this.props.reportDetail.selectedReport.state === "approved") {
                return true;
            } else if (this.props.reportDetail.selectedReport.state === "open") {
                return !isOwnReport && !isSharedWithUser;
            } else if (this.props.reportDetail.selectedReport.state === "closed") {
                return true;
            }
            return false;
        }
    }, {
        key: "render",
        value: function render() {
            var _this2 = this;

            var isReportModificationDisallowed = this.isReportModificationDisallowed();
            var body = null;
            var emptyState = null;
            if (this.props.currentReportData.dataEntries.length > 0) {
                body = React.createElement(_reactBootstrap.Table, null, this.buildTableHeader(), this.buildTableBody());
            } else {
                emptyState = React.createElement("div", { styleName: "empty-container" }, React.createElement(_reactIntl.FormattedMessage, { id: "reportDetail.type.empty.crossReferences", values: { namePlural: this.props.currentReportData.dataDefinition.namePlural } }));
            }
            var tempDataDefintion = this.props.currentReportData.dataDefinition;
            return React.createElement("div", { styleName: "content" }, React.createElement(_reactBootstrap.Grid, { fluid: true }, React.createElement(_reactBootstrap.Row, null, React.createElement(_reactBootstrap.Col, { xs: 12 }, function () {
                if (_this2.props.reportDetail.selectedReport.userUid === _this2.props.user.appUserProfile.uid) {
                    return React.createElement(_reactBootstrap.Button, { className: "pull-right", disabled: isReportModificationDisallowed, bsStyle: "primary", onClick: function onClick() {
                            if (isReportModificationDisallowed === false) {
                                _this2.showModal("add", true);
                            }
                        } }, React.createElement("i", { className: "fa fa-plus" }), " ", _this2.props.currentReportData.dataDefinition.nameSingular, " ", React.createElement(_reactIntl.FormattedMessage, { id: "reportDetail.type.empty.postfix" }));
                }
            }())), React.createElement(_reactBootstrap.Row, null, React.createElement(_reactBootstrap.Col, { xs: 12 }, body))), emptyState, React.createElement(_ReportDetailAddEditTypeModal2.default, { saveReportBeforeAddType: true, mode: "add", reportDataDefinitionUid: this.props.currentReportData.dataDefinition.uid, onClose: function onClose() {
                    return _this2.showModal("add", false);
                }, onSuccess: function onSuccess() {
                    return _this2.showModal("add", false);
                }, showModal: this.state.showModal === "add" }), React.createElement(_ReportDetailDeleteTypeContentModal2.default, { saveReportBeforeDeleteType: true, currentReportData: this.props.currentReportData, selectedReportContent: this.state.selectedItem, onClose: function onClose() {
                    return _this2.showModal("delete", false);
                }, onSuccess: function onSuccess() {
                    return _this2.showModal("delete", false);
                }, showModal: this.state.showModal === "delete" }));
        }
    }]);

    return ReportDetailTypeContent;
}(React.Component);
ReportDetailTypeContent = __decorate([_reactIntl.injectIntl, (0, _reactRedux.connect)(function (state) {
    return {
        reportDetail: state.reportDetail,
        user: state.user,
        auth: state.auth
    };
}), (0, _reactCssModules2.default)(styles)], ReportDetailTypeContent);
exports.default = ReportDetailTypeContent;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/containers/reportDetail/ReportDetailTypeContent.tsx
 ** module id = 1281
 ** module chunks = 0
 **/